export default __webpack_public_path__ + "static/cloudator-3-thumb-b228f416d958aa744f9701d279f0f4f1.png";